
export const getContractId = (state) => 
	state.context.contract ? state.context.contract.contractId : null;
